<template>
  <div>
    <!-- Pestaña 8 · WhatsApp (placeholder). El reporte 8 (app-conversion) ya existe en
         backend; la pestaña se habilita cuando whatsapp.channel esté activo. -->
    <exec-placeholder
      title="WhatsApp — atención y conversión"
      message="Este canal se habilitará cuando el flag whatsapp.channel esté activo. La atención y conversión de la app propia se reporta en el endpoint app-conversion."
    />
  </div>
</template>

<script>
import ExecPlaceholder from './ExecPlaceholder.vue';
// Pestaña 8 · WhatsApp (doc 04 §3, reporte 8). Oculta hasta whatsapp.channel.
export default { name: 'ExecWhatsapp', components: { ExecPlaceholder }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
